"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _LineChart = _interopRequireDefault(require("@/components/Charts/LineChart"));

var _lang = _interopRequireDefault(require("@/lang"));

var _elementUi = require("element-ui");

var _vuex = require("vuex");

var _dateformart = require("@/utils/dateformart");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _SummaryPopup = _interopRequireDefault(require("@/components/SummaryPopup"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "statisticalMonChannel:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    lineChart: _LineChart.default,
    PermissionSimplePage: _PermissionSimplePage.default,
    SummaryPopup: _SummaryPopup.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['channelOperatorList', 'smsNumberAreaOption', 'moneyTypeFromOption'])),
  data: function data() {
    return {
      rerender: false,
      labelInChart: [],
      dataForChart: [],
      dataCollection: null,
      tableKey: 0,
      list: null,
      total: 0,
      chartLoading: true,
      listLoading: true,
      time: null,
      channelOption: [],
      statisticalText: '',
      timeList: [(0, _dateformart.getPreviousMonBegin)(), (0, _dateformart.getPreviousMonEnd)()],
      internationalChannelOperatorList: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        channelId: "",
        moneyTypeTo: "",
        channelOperator: "",
        smsNumberProvince: "",
        statisticalStartTime: "",
        statisticalEndTime: "",
        countryName: []
      },
      viewSummary: false,
      summaryList: []
    };
  },
  created: function created() {
    this.getPayChannelList();
    this.getChart();
    this.getList();
    this.fillData();
    this.initInternationalOperatorInCascader();
  },
  mounted: function mounted() {
    this.fillData();
  },
  methods: {
    fillData: function fillData() {
      this.dataCollection = {
        labels: this.labelInChart,
        datasets: [{
          label: _lang.default.t("SMS.sixMonthDataForApi"),
          data: this.dataForChart
        }]
      };
    },
    // setDefaultTime() {
    //   var date = new Date(),
    //     y = date.getFullYear(),
    //     m = date.getMonth();
    //   var firstDay = new Date(y, m - 1, 1);
    //   var lastDay = new Date(y, m, 0);
    //   lastDay.setHours(23, 59, 59, 0);
    //   this.listQuery.timeList = [
    //     this.dateFormat(firstDay),
    //     this.dateFormat(lastDay),
    //   ];
    // },
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getPayChannelList: function getPayChannelList() {
      var _this = this;

      _httpUtils.default.post("payChannel", "getPayChannelOption", null, {}).then(function (res) {
        _this.channelOption = res.data;
      }).catch(function (err) {
        _this.$notify({
          title: _this.$t("common.error"),
          message: _this.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    getQueryParams: function getQueryParams() {
      var createStartTime, createEndTime, smsNumberProvince, channelOperator; //Check is international platform or China platform

      if (this.$store.getters.isInternational || this.$store.getters.isChina) {
        //International platform only support search by country name and international channel operator
        if (this.$store.getters.isInternational) {
          if (this.listQuery.countryName && this.listQuery.countryName[0]) {
            smsNumberProvince = this.listQuery.countryName[0];
          }

          if (this.listQuery.countryName && this.listQuery.countryName[1]) {
            channelOperator = this.listQuery.countryName[1];
          }
        } else {
          channelOperator = this.listQuery.channelOperator;
        }
      } else {
        //Fill in parameters if exist
        if (this.listQuery.countryName && this.listQuery.countryName[0]) {
          smsNumberProvince = this.listQuery.countryName[0];
        }

        if (this.listQuery.channelOperator) {
          channelOperator = this.listQuery.channelOperator;
        }

        if (this.listQuery.countryName && this.listQuery.countryName[1]) {
          channelOperator = this.listQuery.countryName[1];
        }
      }

      if (!this.timeList) {
        createStartTime = (0, _dateformart.getPreviousMonBegin)();
        createEndTime = (0, _dateformart.getPreviousMonEnd)();
      } else {
        createStartTime = this.timeList[0];
        createEndTime = this.timeList[1];
      }

      return {
        pageNum: this.listQuery.pageNum,
        pageSize: this.listQuery.pageSize,
        channelId: this.listQuery.channelId,
        moneyTypeTo: this.listQuery.moneyTypeTo,
        operator: channelOperator,
        smsNumberProvince: smsNumberProvince,
        statisticalStartTime: createStartTime,
        statisticalEndTime: createEndTime
      };
    },
    getChart: function getChart() {
      var _this2 = this;

      // this.listLoading = true;
      // let startTime = new Date(Date.now());
      // startTime = this.dateFormat(startTime.setMonth(startTime.getMonth() - 6));
      // let endTime = new Date(Date.now());
      // endTime = this.dateFormat(endTime.setSeconds(-1));
      // let query = {
      //   pageSize: 1000000,
      //   statisticalStartTime: startTime,
      //   statisticalEndTime: endTime,
      // };
      _httpUtils.default.post("statisticalMonChannel", "getMonChannelChart", null, null).then(function (res) {
        _this2.labelInChart = res.data.keys;
        _this2.dataForChart = res.data.values;
        _this2.chartLoading = false;

        _this2.fillData();

        _this2.$nextTick(function () {
          _this2.$refs.lineChart.initChart();
        });
      }).catch(function (err) {
        _this2.$message({
          type: "error",
          message: err.message
        });
      });
    },
    initInternationalOperatorInCascader: function initInternationalOperatorInCascader() {
      var _this3 = this;

      this.smsNumberAreaOption.forEach(function (numberArea) {
        var item = {
          label: numberArea.display_name,
          value: numberArea.key,
          children: [] // if you want to keep the cascader open, you have to add a "children: []"

        };

        _this3.internationalChannelOperatorList.push(item);
      });
    },
    getList: function getList() {
      var _this4 = this;

      // Reset Summary (including change page)
      this.viewSummary = false;
      this.summaryList = [];
      this.listLoading = true;
      var params = this.getQueryParams();

      _httpUtils.default.post("statisticalMonChannel", "list", null, params).then(function (res) {
        _this4.list = res.data.rows;
        _this4.total = res.data.total;
        _this4.statisticalText = "";
        setTimeout(function () {
          _this4.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this4.$message({
          type: "error",
          message: err.message
        });
      }).finally(function () {
        _this4.listLoading = false;

        if (_this4.summaryAppended === true) {
          _this4.list.push(_this4.summaryAppendData);
        }
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.getList(); // Reset Summary only when filter change
      // this.viewSummary = false;
      // this.summaryList = [];
    },
    getChannelOperatorList: function getChannelOperatorList(value) {
      var _this5 = this;

      if (!this.listQuery.countryName) {
        return;
      }

      this.listQuery.channelOperator = null;
      var params = value[0]; // value is an array, so the selected value is value[0]
      //If area match selected value, update item with new value

      this.internationalChannelOperatorList.find(function (channelOperator) {
        if (channelOperator.value == params) {
          if (channelOperator.children.length === 0) {
            _httpUtils.default.post("mobileArea", "getChannelOperatorList", null, params).then(function (res) {
              //Handle data from backend
              var internationalChannelOperatorList = res.data;

              if (internationalChannelOperatorList != null) {
                //Handle children array for area
                var newInternationalChannelOperatorItem = [];
                internationalChannelOperatorList.forEach(function (item) {
                  var channelOperator = {
                    label: item,
                    value: item
                  };
                  newInternationalChannelOperatorItem.push(channelOperator);
                });
                var newChannelOperator = {
                  label: channelOperator.label,
                  value: channelOperator.value,
                  children: newInternationalChannelOperatorItem //Update item in internationalChannelOperatorList with same location

                };

                _this5.$set(_this5.internationalChannelOperatorList, _this5.internationalChannelOperatorList.indexOf(channelOperator), newChannelOperator);
              }
            });
          }

          return;
        }
      });
    },
    getStatistic: function getStatistic() {
      var _this6 = this;

      var params = this.getQueryParams();

      _httpUtils.default.post("statisticalMonChannel", "sum", null, params).then(function (res) {
        var data = res.data; // let dollarSign;
        // if (this.$store.getters.isInternational) {
        //   dollarSign = "USD" + this.$USDIcon;
        // } else {
        //   dollarSign = "RMB" + this.$RMBIcon;
        // }

        _this6.summaryList = [[{
          label: 'SMS.totalText',
          value: data.totalCount || 0,
          unit: 'SMS.tiao'
        }], [{
          label: "SMS.orderCreateFailCount",
          value: data.orderCreateFailCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.orderCreateSuccessCount",
          value: data.orderCreateSuccessCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelSubmitFailCount",
          value: data.channelSubmitFailCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelSubmitSuccessCount",
          value: data.channelSubmitSuccessCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelNotifyFailCount",
          value: data.channelNotifyFailCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelNotifySuccessCount",
          value: data.channelNotifySuccessCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.depositedCount",
          value: data.depositedCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.refundCount",
          value: data.refundCount || 0,
          unit: 'SMS.tiao'
        }], [{
          label: "SMS.amountOfConsumption",
          value: data.processConsumeAmount,
          unit: 'USD'
        }, {
          label: "SMS.channelCost",
          value: data.processChannelCostAmount,
          unit: 'USD'
        }, {
          label: "SMS.agencyProfit",
          value: data.processAgentIncomeAmount,
          unit: 'USD'
        }, {
          label: "SMS.platformProfit",
          value: data.processIncomeAmount,
          unit: 'USD'
        }]];
      }).catch(function (err) {
        _this6.$notify({
          title: _this6.$t("common.error"),
          message: _this6.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      }).finally(function () {
        _this6.viewSummary = true;
      });
    },
    handleExportReport: function handleExportReport() {
      var _this7 = this;

      var excelName = _lang.default.t("SMS.channelMonthlyReport") + ".xlsx";
      var params = this.getQueryParams(); // httpUtils.getByBlob("statisticalMonChannel", "excel", params, excelName);

      _httpUtils.default.post("statisticalMonChannel", "excel", null, params);

      _elementUi.MessageBox.confirm(_lang.default.t("warningMessage.pleaseWaitForExportAndNavigateMessage"), _lang.default.t("warningMessage.pleaseWaitForExportAndNavigateTitle"), {
        confirmButtonText: _lang.default.t("warningMessage.exportAndNavigateConfirmButtonText"),
        cancelButtonText: _lang.default.t("warningMessage.exportAndNavigateCancelButtonText"),
        type: 'warning'
      }).then(function () {
        // route to exported excel page
        _this7.$router.push({
          name: "exportedExcel:view"
        });
      }).catch(function () {
        return null;
      });
    },
    changeChannelOperator: function changeChannelOperator() {
      //Reset value in countryName
      this.listQuery.countryName = [];
    },
    convertOperatorName: function convertOperatorName(name) {
      if (!this.channelOperatorList || !this.channelOperatorList.length) return;
      var operator = this.channelOperatorList.find(function (item) {
        return item.key === name;
      });

      if (operator) {
        return operator.display_name;
      } else {
        return name;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;